import axios from 'axios';
import { getUserToken } from '../../utils/localStoarege';
import { hudGetMedicineOintmentsApiUrl, hudGetMedicineTabletsApiUrl, hudMedicineApiCRUDUrl } from '../../constants/apis/hud_apis';

export const getHudMedicines = async () => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(hudMedicineApiCRUDUrl, config);
    return response;
};

export const getHudTablets = async () => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(hudGetMedicineTabletsApiUrl, config);
    return response;
};

export const getHudOintments = async () => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(hudGetMedicineOintmentsApiUrl, config);
    return response;
};
